import { Quote } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { LeafCutout } from "@/components/kit/Decor";
import { SITE, SONY_QUOTE } from "@/lib/content";

export function QuoteBand() {
  return (
    <section data-testid="quote-band" className="relative overflow-hidden bg-beige py-20 sm:py-28">
      <LeafCutout variant="b" className="-left-16 top-0 z-0 h-24 w-44 opacity-70 sm:top-6 sm:h-44 sm:w-80 sm:opacity-100" speed={0.08} />
      <div className="wrap relative z-10 grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="font-script text-5xl leading-[1.05] text-forest sm:text-6xl lg:text-7xl" data-testid="quote-band-script">
            <MaskLines lines={["A healthier, brighter", <span key="y">you in <span className="text-gold-ink">120 days.</span></span>]} />
          </p>
        </div>
        <Reveal delay={0.1} className="lg:col-span-6">
          <figure className="relative rounded-[28px] bg-beige-soft p-8 ring-1 ring-forest/10 sm:p-10" data-testid="sony-quote">
            <Quote className="h-8 w-8 text-gold" />
            <blockquote className="mt-4 font-display text-3xl leading-snug text-forest sm:text-4xl">{SONY_QUOTE}</blockquote>
            <figcaption className="mt-6 flex items-center gap-4">
              <img src="/images/sony-portrait.jpg" alt={`${SITE.founder}, wellness coach`} loading="lazy" className="h-14 w-14 rounded-full object-cover object-top ring-2 ring-gold/60" />
              <span>
                <span className="block font-script text-3xl leading-none text-forest">{SITE.founder}</span>
                <span className="text-xs font-semibold uppercase tracking-[0.2em] text-charcoal-soft">Wellness Coach</span>
              </span>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
